





























import { mapState } from 'vuex';
export default {
	name: 'DealerHeader', 
	computed: {
		...mapState({
			app(): any { return this.$store.state.app },
			dealer(): any { return this.$store.state.dealer },
			vehicle(): any { return this.$store.state.vehicle }
		}),
		modelName(): string {
			return (this.vehicle as any).model;
		}
	}
}
